import { render, staticRenderFns } from "./FontSizePicker.vue?vue&type=template&id=42b8821c&scoped=true&"
import script from "./FontSizePicker.vue?vue&type=script&lang=js&"
export * from "./FontSizePicker.vue?vue&type=script&lang=js&"
import style0 from "./FontSizePicker.vue?vue&type=style&index=0&id=42b8821c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8821c",
  null
  
)

export default component.exports